export const PARAM_ARRIVAL_DATE_TIME = 'arrivalDateTime'
export const PARAM_DEPARTURE_DATE_TIME = 'departureDateTime'
export const PARAM_REDIRECT = 'redirect'
export const PARAM_SORT = 'sort'
export const REDIRECT_QRCODE = 'qrcode'
